module.exports = __webpack_public_path__ + "img/chevron-left.2134517c.svg";